import React from 'react';
import { User, LogOut } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';

const APP_VERSION = '2.0.0';

/**
 * UserInfoCard - Affiche les informations de l'utilisateur connecté
 */
const UserInfoCard = ({ user, onLogout }) => {
  return (
    <Card className="relative bg-slate-950/40 backdrop-blur-xl border-slate-800/60">
      <CardHeader>
        <CardTitle className="text-xl md:text-2xl font-orbitron uppercase tracking-wider text-cyan-400 flex items-center justify-between">
          <div className="flex items-center">
            <User className="w-5 h-5 md:w-6 md:h-6 mr-2 md:mr-3" />
            Informations
          </div>
          <span className="text-xs font-mono text-slate-600">v{APP_VERSION}</span>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between p-4 bg-slate-900/50 rounded-lg border border-slate-800">
          <div>
            <p className="text-sm text-slate-500 uppercase tracking-wider">Email</p>
            <p className="text-lg text-slate-200 font-medium">{user?.email || 'Non connecte'}</p>
            <p className="text-sm mt-1">
              <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded font-mono text-xs uppercase tracking-wider ${
                user?.grade === 'amiral' 
                  ? 'bg-amber-500/15 text-amber-400 border border-amber-500/30' 
                  : user?.grade === 'capitaine'
                  ? 'bg-emerald-500/15 text-emerald-400 border border-emerald-500/30'
                  : 'bg-cyan-500/15 text-cyan-400 border border-cyan-500/30'
              }`}>
                {user?.grade === 'amiral' ? 'Amiral' : user?.grade === 'capitaine' ? 'Capitaine' : 'Lieutenant'}
              </span>
            </p>
          </div>
          <Button
            onClick={onLogout}
            className="bg-red-500/10 hover:bg-red-500/20 text-red-400 border-2 border-red-500/50 hover:border-red-400 rounded-lg px-4 py-2 font-semibold"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Déconnexion
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default UserInfoCard;
